import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MembersModule } from './modules/members/members.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PlotsModule } from './modules/plots/plots.module';
import { ItemsModule } from './modules/items/items.module';
import { API_BASE_URL } from './shared/tokens/api.tokens';
import { AppConfigService } from './shared/services/app-config.service';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { MemberPlotsModule } from './modules/member-plots/member-plots.module';
import { PlotItemsModule } from './modules/plot-items/plot-items.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AdminModule } from './modules/admin/admin.module';
import { LOCALE_ID } from '@angular/core';
import localeEnGb from '@angular/common/locales/en-GB';
import { registerLocaleData } from '@angular/common';
import { InvoicesModule } from './modules/invoices/invoices.module';
import { WaitingListApplicantsModule } from './modules/waiting-list-applicants/waiting-list-applicants.module';

registerLocaleData(localeEnGb);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MembersModule,
    PlotsModule,
    ItemsModule,
    SharedModule,
    LayoutModule,
    AdminModule,
    MemberPlotsModule,
    PlotItemsModule,
    InvoicesModule,
    WaitingListApplicantsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    })
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: API_BASE_URL,
      useFactory: (configService: AppConfigService) => configService.getApiBaseUrl(),
      deps: [AppConfigService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-GB'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
